// extracted by mini-css-extract-plugin
module.exports = {"tippy":"Tippy_tippy__3d3sf"};